import React from "react";
import { dispatch } from "@rematch/core";
import { withRouter } from "react-router-dom";
import { Form } from "formsy-semantic-ui-react";
import noIntegrationToShow from "../../../../images/common/noINtegrationConfigured.png";
import {
  List,
  Card,
  Dropdown,
  Image,
  Container,
  Header,
  Button,
  Label,
} from "semantic-ui-react";
import axios from "axios";
import {
  singleLineText,
  singleLinePassword,
} from "../../../common/RegexValidation";
import _ from "lodash";
class AllIntegrations extends React.Component {
  componentWillMount() { }
  render() {
    const activeIntegrations = this.props.selectedAccount &&
    this.props.selectedAccount.integrations &&
    this.props.selectedAccount.integrations.filter(
      (el) => el.isActive
    )
    return (
      <div className="general-setting">
        {(this.props.selectedAccount.planId.includes("enterprise") ||
        this.props.selectedAccount.planId.includes("premium")) && (activeIntegrations && activeIntegrations.length !==0)  ? (
          <Card>
            <Card.Header>
              Integrations
              <Label size="mini" className="mar_lr_5">
                {" "}
                { activeIntegrations && activeIntegrations.length}
              </Label>
            </Card.Header>
            <Card.Content className="pad_0">
              <List divided verticalAlign="middle">
                {this.props.integrationsList &&
                this.props.integrationsList.data.length > 0 &&
                this.props.selectedAccount
                  ? this.props.integrationsList.data.map((integration) => {
                      return (
                        <List.Item className="singleLine">
                          {this.props.selectedAccount &&
                          this.props.selectedAccount.integrations &&
                          this.props.selectedAccount.integrations.some(
                            (el) => ((el.id._id ? el.id._id : el.id) === integration._id) && el.isActive
                          ) ? (
                            // <div>
                            <List.Item className="singleLine">
                              <List.Content
                                floated="right"
                                className="clr-blue"
                              >
                                Enabled
                              </List.Content>

                              <List.Content>
                                <span>
                                  <Image
                                    avatar
                                    src={integration.image}
                                    className="w_24 h_24"
                                  />
                                  {integration.label} &nbsp;
                                </span>
                                {/* <List.Header>{integration.label}</List.Header> */}
                              </List.Content>
                              </List.Item>
                            // </div>
                          ) : null}
                        </List.Item>
                      );
                    })
                  : null}
              </List>
            </Card.Content>
          </Card>
        ) : (
          <Container fluid className="pad_40">
            <Image
              src={noIntegrationToShow}
              className="landingImage"
              size="large"
              centered={true}
              style={{ width: "400px", height: "300px" }}
            />
            <div className="text-center">
              <h1 className="ff_b">No integrations configured currently</h1>
              {/* <Button onClick={this.viewPlans} primary>Upgrade Plans</Button> */}
            </div>
          </Container>
        )}
      </div>
    );
  }
}

export default withRouter(AllIntegrations);
